module.exports = __webpack_public_path__ + "static/media/VestasSans-Medium.d06a63c6.woff";